module.exports = __webpack_public_path__ + "media/images/athletes/927-0d35a8202a782ccadc364721c6112982.png";